import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';

const SiContainerd = React.forwardRef(function SiContainerd2({ title = "containerd", color = "currentColor", size = 24, ...others }, ref) {
  if (color === "default") {
    color = "#575757";
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      ref,
      ...others,
      children: [
        /* @__PURE__ */ jsx("title", { children: title }),
        /* @__PURE__ */ jsx("path", { d: "M3.629 0v24H20.37V0zM17.59 21.208H6.421V10.604h7.812V6.692h3.346v14.516zm-7.823-7.812h4.466v5.02H9.767z" })
      ]
    }
  );
});
const SiContainerd$1 = SiContainerd;

export { SiContainerd$1 as default };
